import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("vyastra_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
            localStorage.removeItem("vyastra_token");
            window.location.href = "/login";
        }
        return Promise.reject(err);
    }
);

export const fmtMoney = (n, ccy = "INR") => {
    const num = Number(n || 0);
    const opts = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    try {
        return new Intl.NumberFormat(ccy === "INR" ? "en-IN" : "en-US", { style: "currency", currency: ccy, ...opts }).format(num);
    } catch {
        return `${ccy} ${num.toLocaleString("en-IN", opts)}`;
    }
};

export const fmtNum = (n) =>
    Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtCompact = (n, ccy = "INR") => {
    const num = Number(n || 0);
    const sym = ccy === "INR" ? "₹" : ccy === "USD" ? "$" : ccy === "EUR" ? "€" : ccy + " ";
    if (Math.abs(num) >= 1e7) return `${sym}${(num / 1e7).toFixed(2)} Cr`;
    if (Math.abs(num) >= 1e5) return `${sym}${(num / 1e5).toFixed(2)} L`;
    if (Math.abs(num) >= 1e3) return `${sym}${(num / 1e3).toFixed(1)}K`;
    return `${sym}${num.toFixed(0)}`;
};

export const fmtDate = (s) => {
    if (!s) return "—";
    try {
        return new Date(s).toLocaleDateString("en-IN", { year: "numeric", month: "short", day: "2-digit" });
    } catch {
        return s;
    }
};

export const today = () => new Date().toISOString().slice(0, 10);
export const daysAgo = (n) => new Date(Date.now() - n * 86400000).toISOString().slice(0, 10);
